__webpack_require__.p = "https://cdn.bikerbetten.de/_next/";